var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5569 7H12.1635L11.9085 7.32039L5.46996 15.4095L5 16L5.46996 16.5904L11.9085 24.6796L12.1635 25H12.5569H24.1485H25V24.0892V18.9467H23.297V23.1784H14.419L19.7415 16.5958L20.2233 16L19.7415 15.4042L14.419 8.82164H23.297V13.0533H25V7.91082V7H24.1485H12.5569ZM12.5619 9.30956L7.23666 16L12.5619 22.6905L17.9716 16L12.5619 9.30956Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEna);
export default __webpack_public_path__ + "static/media/ENA.61dbc0708389a0202add7db9438418ba.svg";
export { ForwardRef as ReactComponent };